import { FiAlertTriangle } from 'react-icons/fi';
import { Form } from 'react-bootstrap';
import { Option } from '../../models/generic';
import SelectMulti from '../SelectMulti/SelectMulti';
import cn from 'classnames';
import siteMessages from '../../pages/root/siteMessages';
import { useIntl } from 'react-intl';

interface Props {
  prefix?: string;
  controlId: string;
  label?: string;
  isMulti: boolean;
  options: Option[];
  value: any;
  error: any;
  setFieldValue: any;
}

const SelectQuestion = (props: Props) => {
  const intl = useIntl();

  return (
    <Form.Group controlId={props.controlId} className="w-100">
      {props.label && (
        <Form.Label className="fw-bold">
          <span dangerouslySetInnerHTML={{ __html: props.label }} />
        </Form.Label>
      )}
      <SelectMulti
        id={props.controlId}
        className={cn(
          props.error ? 'invalid-select' : '',
          props.isMulti ? 'nemo-select-multi' : ''
        )}
        isMulti={props.isMulti}
        options={props.options}
        value={props.value}
        onChange={(value: any) =>
          props.setFieldValue(
            props.prefix
              ? `${props.prefix}.${props.controlId}`
              : props.controlId,
            value
          )
        }
        placeholder={
          props.isMulti
            ? intl.formatMessage({ ...siteMessages.selectMultiPlaceholder })
            : intl.formatMessage({ ...siteMessages.selectSinglePlaceholder })
        }
      />
      {props.error && (
        <div className="feedback">
          <FiAlertTriangle className="mb-1 me-1" />
          {props.error}
        </div>
      )}
    </Form.Group>
  );
};

export default SelectQuestion;
